/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Upgrade_Alert_TitleInputs */

const en_mobile_upgrade_alert_title = /** @type {(inputs: Mobile_Upgrade_Alert_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update available`)
};

const es_mobile_upgrade_alert_title = /** @type {(inputs: Mobile_Upgrade_Alert_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualización disponible`)
};

/**
* | output |
* | --- |
* | "Update available" |
*
* @param {Mobile_Upgrade_Alert_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_upgrade_alert_title = /** @type {((inputs?: Mobile_Upgrade_Alert_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Upgrade_Alert_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_upgrade_alert_title(inputs)
	return en_mobile_upgrade_alert_title(inputs)
});